export const WINDOW_DEPENDENCY_KEY = "Dimensions.window";
export const SCREEN_DEPENDENCY_KEY = "Dimensions.screen";
